import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend, Label } from "recharts";
import { BarChart2 } from "lucide-react";
import { motion } from "framer-motion";

const SpendingTrends = ({ data }) => {
    if (!data || data.length === 0) return null;

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 mt-12"
        >
            <div className="d-flex align-items-center gap-2 mb-6">
                <div className="p-2 bg-blue-50 rounded-lg text-blue-600">
                    <BarChart2 size={20} />
                </div>
                <h3 className="text-lg font-bold text-gray-800 m-0">Historical Spending Trends (US$ Million)</h3>
            </div>

            <div style={{ height: 400 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data} margin={{ top: 20, right: 30, left: 30, bottom: 40 }}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f3f4f6" />
                        <XAxis dataKey="year" axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#6b7280' }}>
                            <Label value="Calendar Year" offset={-20} position="insideBottom" style={{ fontSize: '12px', fill: '#9ca3af', fontWeight: 600 }} />
                        </XAxis>
                        <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: '#6b7280' }}>
                            <Label value="Spending (US$ Million)" angle={-90} position="insideLeft" style={{ textAnchor: 'middle', fontSize: '12px', fill: '#9ca3af', fontWeight: 600 }} offset={0} />
                        </YAxis>
                        <Tooltip
                            contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' }}
                            formatter={(value) => [`$${value.toLocaleString()}M`, ""]}
                        />
                        <Legend verticalAlign="top" align="right" iconType="circle" wrapperStyle={{ paddingBottom: '20px' }} />
                        <Bar dataKey="private_residential_million" name="Private Residential" fill="#4F46E5" radius={[4, 4, 0, 0]} />
                        <Bar dataKey="private_nonresidential_million" name="Private Non-Res" fill="#10B981" radius={[4, 4, 0, 0]} />
                        <Bar dataKey="public_infrastructure_million" name="Public Infra" fill="#F59E0B" radius={[4, 4, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </motion.div>
    );
};

export default SpendingTrends;
